module.exports = __webpack_public_path__ + "img/bankystudio.png.659fea64.webp";